export const SET_BRANDS = 'SET_BRANDS'
export const SET_SELECTED_BRAND = 'SET_SELECTED_BRAND'
export const SET_ADMIN_EMAIL= 'SET_ADMIN_EMAIL'
export const SET_FIN_YEAR = 'SET_FIN_YEAR'
export const SET_ROLE_AND_PERMISSIONS = 'SET_ROLE_AND_PERMISSIONS'
export const SET_BRAND_FIN_YEAR = 'SET_BRAND_FIN_YEAR'



// WEBPACK FOOTER //
// ./src/store/global/types.js